<div class="slide-toggle">
    <mat-slide-toggle
        (change)="toggle()"
        [matTooltip]="tooltip !== '' ? tooltip : ''"
        [checked]="value !== undefined ? value : model ?? false"
        color="primary"
        [name]="formControlName"
        [color]="color"
        porAddFeature
        class="mat-toggle"
        [featureName]="featureName"></mat-slide-toggle>
</div>
